/* eslint-disable import/prefer-default-export */
import axios from '../axios';
import { useMutation, useQuery } from 'react-query';
import { filter } from 'lodash';

export function useUserSuggestions(query, corporateId = '', isAdmin = 0) {
  const apiURL = `/corporate/searchCustomerList?search=${query}`;
  return useQuery(
    ['customerSuggestion', query?.length],
    () => axios.get(apiURL).then((res) => res.data),
    {
      enabled: !!(query?.length > 0),
    },
  );
}

export function useGetCorporateUserSuggestionsByName(query, corporateId = '') {
  const apiURL = `/corporate/suggestion-name?search=${query}`;
  return useQuery(
    ['userSuggestionsByName', query.length],
    () => axios.get(apiURL).then((res) => res.data),
    {
      enabled: !!(query?.length > 0),
    },
  );
}

export function useGetCorporateUserSuggestionsByEmail(query, corporateId = '') {
  const apiURL = `/corporate/suggestion-email?search=${query}`;
  return useQuery(
    ['userSuggestionsByEmail', query.length],
    () => axios.get(apiURL).then((res) => res.data),
    {
      enabled: !!(query?.length > 0),
    },
  );
}

// Add Corporate User
export function useAddCorporateUserMutation() {
  return useMutation(
    (corporateUser) => axios.post(`/corporate/employee`, corporateUser),
    {
      onSuccess: (res) => ({ error: res.error, data: res.data }),
      onError: (err) => ({ data: err.response.data }),
    },
  );
}

// Edit Corporate User
export function useEditCorporateUserMutation() {
  return useMutation((corporateUser) =>
    axios.put(`/corporate/employee/${corporateUser.ID}`, {
      LOCATION: corporateUser.LOCATION,
      IS_ACTIVE: corporateUser.IS_ACTIVE ? 1 : 0,
    }),
  );
}

// List Corporate Users
export function useFetchCorporateUsers({ query, offset, limit }) {
  return useQuery(['/corporate/employee/list', query, offset, limit], () =>
    axios
      .get(`/corporate/employee`, {
        params: {
          query,
          offset,
          limit,
        },
      })
      .then((result) => {
        const usersData = {
          data: filter(result.data?.data, (item) => item),
          count: result.data?.count,
        };
        return usersData;
      }),
  );
}

// Get Corporate User By Id
export function useFetchCorporateUserByID(userId) {
  return useQuery(['corporateUser/id', userId], () =>
    axios.get(`/corporateUser/${userId}`).then((result) => result?.data),
  );
}
